const filter = require('lodash/filter')
const map = require('lodash/map')

module.exports = ['$translate', '$q', 'User', '$rootScope',
  function ($translate, $q, User, $rootScope) {
    function Message(oMessageInfo) {
      this.messageInfo = oMessageInfo
      this.id = oMessageInfo ? oMessageInfo.id : ''
    }

    Message.prototype.updateMessageInfos = function (oAttrs, aMessages, mboxa) {
      const that = this
      aMessages = aMessages || [that]
      const aIds = []
      for (let i = 0; i < aMessages.length; ++i) {
        for (const sAttrKey in oAttrs) {
          if (sAttrKey == 'flags') {
            const oFlags = oAttrs[sAttrKey]
            for (const sFlagKey in oFlags) {
              aMessages[i]['messageInfo']['flags'][sFlagKey] = oFlags[sFlagKey]
            }
          } else {
            aMessages[i]['messageInfo'][sAttrKey] = oAttrs[sAttrKey]
          }
        }
        aIds.push(aMessages[i].messageInfo.id)
      }
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:updateMessageInfos',
          sid: User.getCurrentUser().sid
        },
        data: {
          ids: aIds,
          attrs: oAttrs,
          mboxa: mboxa
        },
        cache: false
      }).then(function (data, status, headers, config) {
        if (data.code == 'S_OK') {
          deferred.resolve(that.id)
          $rootScope.$emit('FOLDER.UNREADREFRESH')
        }
      })
      return deferred.promise
    }

    Message.prototype.mark = function (sFlag, bValue, aMessages, mboxa) {
      const that = this
      const oFlags = {}
      oFlags[sFlag] = bValue

      return that.updateMessageInfos({
        flags: oFlags,
      }, aMessages, mboxa)
    }

    Message.prototype.remove = function (aMessages, mboxa) {
      aMessages = aMessages || [this]

      const _mboxa = mboxa === '' ? '' : mboxa || User.getSelectedAccountSymbol()
      const moveToTrash = map(filter(aMessages, item => item.messageInfo.fid !== 4), item => item.messageInfo.id)
      const removePermanently = map(filter(aMessages, item => item.messageInfo.fid === 4), item => item.messageInfo.id)
      const promises = []

      removePermanently.length && promises.push(
        User.getCurrentUser().simpleCall({
          query: {
            func: 'mbox:deleteMessages',
            sid: User.getCurrentUser().sid
          },
          data: {
            ids: removePermanently,
            mboxa: _mboxa
          },
          cache: false
        }).then(_ => removePermanently)
      )

      moveToTrash.length && promises.push(
        User.getCurrentUser().simpleCall({
          query: {
            func: 'mbox:updateMessageInfos',
            sid: User.getCurrentUser().sid
          },
          data: {
            ids: moveToTrash,
            attrs: { fid: 4 },
            mboxa: _mboxa
          },
          cache: false
        }).then(_ => moveToTrash)
      )

      return $q.all(promises)
    }

    Message.prototype.moveToFolder = function (aMessages, oFolder, mboxa) {
      const deferred = $q.defer()
      if (!aMessages || aMessages.length <= 0 || !oFolder) {
        deferred.reject('ILLEGAL_ARGUMENTS')
        return deferred.promise
      }

      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:updateMessageInfos',
          sid: User.getCurrentUser().sid
        },
        data: {
          ids: aMessages.map(function (oMessage) {
            return oMessage.messageInfo.id
          }),
          attrs: { fid: oFolder.id },
          mboxa: mboxa === '' ? '' : mboxa || User.getSelectedAccountSymbol()
        }
      }).then(function (data) {
        deferred.resolve(data)
      }, function (reason) {
        deferred.reject(reason)
      })

      return deferred.promise
    }

    Message.buildMessages = function (aMessageInfos) {
      const re = []
      for (let i = 0; i < aMessageInfos.length; ++i) {
        re[re.length] = new Message(aMessageInfos[i])
      }
      return re
    }

    return Message
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/Message.js